import * as React from 'react';
import RoutePrivate from 'src/components/router/RoutePrivate';
import ProjectBillingPage from './pages/ProjectBillingPage';
import OfficeExpensePage from './pages/OfficeExpensePage';
import TimeAndExpenseChecklistPage from './pages/TimeAndExpenseChecklistPage';
import TeNonReconPage from './pages/TeNonReconPage';
import TimeAndExpensePage from './pages/TimeAndExpensePage';
import InvoiceMaintenancePage from './pages/InvoiceMaintenancePage';
import InvoiceGroupCoverLetterFormFiller from 'src/components/project-billing/components/InvoiceGroupCoverLetterEntry';
import CostBreakdownPage from './pages/CostBreakdownPage';

export default function getRoutes(isLoggedIn: boolean) {
    return [
        <RoutePrivate key="project-billing" path="/project-billing/approval" component={ProjectBillingPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="office-expenses" path="/project-billing/officeexpenses" component={OfficeExpensePage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="time-and-expense-checklist" path="/project-billing/timeexpensechecklist" component={TimeAndExpenseChecklistPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="time-and-expense-nonrecon" path="/project-billing/nonrecon" component={TeNonReconPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="time-and-expense" path="/project-billing/timeexpense" component={TimeAndExpensePage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="time-and-expense" path="/project-billing/invoice" component={InvoiceMaintenancePage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="project-billing-invoicegroup" path="/project-billing/invoicegroups/coverletter" component={InvoiceGroupCoverLetterFormFiller} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="cost-breakdown" path="/project-billing/costbreakdown" component={CostBreakdownPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="project" path="/project-billing/approval" component={ProjectBillingPage} isLoggedIn={isLoggedIn} />
    ];
}



// WEBPACK FOOTER //
// ./src/components/project-billing/PB.Routes.tsx